import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'product-header',
  template: `<ng-content></ng-content>`,
})
export class ProductHeaderComponent implements OnInit {
  constructor() { }

  ngOnInit() {
  }

}
